// eslint-disable-next-line import/no-cycle
import store from '@/store';
import { userHasAnyRole, TENANT_ROLE_ADMIN } from '@/utils/userRoles';
import { hasValidAdminStepUp } from '@/utils/adminStepUp';

/**
 * CMS entry: admin role + valid adminStepUpUntil claim on JWT.
 * If admin without step-up → redirect to AdminStepUpView.
 */
export function checkContentManagementAccess(to, from, next) {
  const user = store.getters.getUser;
  if (!userHasAnyRole(user, [TENANT_ROLE_ADMIN])) {
    next('/');
    return;
  }

  const token = store.state.auth?.token || localStorage.getItem('jwt');
  if (hasValidAdminStepUp(token)) {
    next();
    return;
  }

  next({
    path: '/auth/admin-step-up',
    query: { redirect: to.fullPath },
  });
}

export default { checkContentManagementAccess };
